import {Injectable} from '@angular/core';
import {DeliveryClient, DeliveryClientConfig, TypeResolver} from 'kentico-cloud-delivery-typescript-sdk';
import {Project} from '../models/project';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class KenticoService {
  private deliveryClient: DeliveryClient;
  private contentItems;

  constructor() {
    const typeResolvers: TypeResolver[] = [
      new TypeResolver('project', () => new Project()),
    ];

    let options = {};

    if (!environment.production) {
      options = {
        enablePreviewMode: true,
        previewApiKey: environment.kenticoConfig.previewApiKey
      };
    }

    this.deliveryClient = new DeliveryClient(new DeliveryClientConfig(
      environment.kenticoConfig.projectId,
      typeResolvers,
      options
    ));

    this.contentItems = this.deliveryClient.items().get().publishReplay(1).refCount();
  }

  getSingleType(type: String): Observable<any> {
    return this.contentItems.map(response => {
      return response.items.filter(item => {
        return item.system.type === type;
      })[0];
    });
  }

  getProjects(): Observable<Project[]> {
    return this.contentItems.map(response => {
      return response.items.filter(item => item.system.type === 'project').sort((projectA, projectB) => {
        return (projectB.dateCompleted.datetime.getTime() - projectA.dateCompleted.datetime.getTime());
      });
    });
  }

  getProject(slug: string): Observable<Project> {
    return Observable.create(observer => {
      this.getProjects().subscribe(projects => {
        observer.next(projects.filter(project => project.slug.value === slug)[0]);
      });
    });
  }

  getNewerProject(project: Project): Observable<Project> {
    return Observable.create(observer => {
      this.getProjects().subscribe(projects => {
        const newerProjects = projects.filter((aProject) => {
          return (aProject.dateCompleted.datetime.getTime() > project.dateCompleted.datetime.getTime());
        });
        observer.next(newerProjects[newerProjects.length - 1]);
      });
    });
  }

  getOlderProject(project: Project): Observable<Project> {
    return Observable.create(observer => {
      this.getProjects().subscribe(projects => {
        observer.next(projects.filter((aProject) => {
          return (aProject.dateCompleted.datetime.getTime() < project.dateCompleted.datetime.getTime());
        })[0]);
      });
    });
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/kentico.service.ts